module.exports = __webpack_public_path__ + "static/media/arrow-left.0cda9b1b.svg";